/* eslint-disable */
export default {
  loading: 'Ladevorgang läuft…',
} as const;

// @key: @#@"loading"@#@ @source: @#@"Loading ..."@#@
